
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.297","height":"14.352"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29564","data-name":"Path 29564","d":"M8.716 10.77v2.311a.771.771 0 01-.77.77H1.27a.77.77 0 01-.77-.77V4.35a.771.771 0 01.77-.77h1.28a6.2 6.2 0 011.027.085m5.135 7.1h2.311a.771.771 0 00.77-.77V6.662A6.154 6.154 0 005.635.5H4.35a.771.771 0 00-.77.77v2.4m5.135 7.1H4.35a.77.77 0 01-.77-.77V3.667m8.216 4.536V6.919a2.311 2.311 0 00-2.311-2.311H8.46a.77.77 0 01-.77-.77V2.811A2.311 2.311 0 005.378.5h-.77","fill":"none","stroke":"#5a677b","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}})])
          )
        }
      }
    